class Banking {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/banking`;

  }

  async getBankAccountStatusByStartupId() {

    const path = `${this.basePath}/status`;

    return this.apiClient.get(path, {}, {});

  }

  async getPopulatedBankAccount() {

    const path = `${this.basePath}/account`;

    return this.apiClient.get(path, {}, {});

  }

}

export default Banking;